import { Alert, Button, Checkbox, List, Modal, Row } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

const CheckboxGroup = Checkbox.Group;

interface ScrollableContainerProps {
  readonly height: string;
}

interface CategoryProps {
  readonly selected: boolean | undefined;
}

export const ScrollableContainer = styled.div<ScrollableContainerProps>`
  overflow: auto;
  height: ${props => props.height}px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BackButton = styled(Button)`
  border-top-right-radius: 50% !important;
  margin-right: 15px;
  background: ${props => props.theme.palette.secondary.light};
  color: ${props => props.theme.palette.text.secondary};
  display: flex;
  align-items: center;
  border: none !important;
  justify-content: center;
  min-width: 40px !important;

  .anticon {
    font-size: 14px;
    margin-bottom: -2px;
    color: ${props => props.theme.palette.text.secondary} !important;
  }

  &:hover,
  &:active,
  &:focus {
    background: ${props => props.theme.palette.secondary.light};
    color: ${props => props.theme.palette.text.secondary};
    border: none;
  }
`;

export const PageHeader = styled(Row)`
  background: ${props => props.theme.palette.background.pearl40};
  padding: 6px 22px;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
`;

export const StickyAlert = styled.div<{ top: number }>`
  position: sticky;
  z-index: 99;
  top: ${({ top }) => `${top}px`};
`;

export const StyledAlert = styled(Alert)`
  &.ant-alert-info {
    background-color: #d8e8ff;
    .ant-alert-icon {
      color: #1890ff;
    }
  }
`;

export const Wrapper = styled.div`
  padding: 10px 30px;
`;

export const CategoryOptions = styled.div`
  display: flex;
  border: 1px solid ${props => props.theme.palette.primary.dark};
  border-radius: 4px;
  margin-bottom: 28px;
`;

export const Category = styled.div<CategoryProps>`
  flex: 1;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: -1px;

  ${props =>
    props.selected &&
    `
    font-weight: bold;
    color: ${props.theme.palette.text.light};
    background: ${props.theme.palette.primary.dark};
    border-radius: 3px 3px 3px 0px;
  `}
`;

export const Text = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-width: 440px;
`;

// FILTER SECTION
export const FiltersContainer = styled.div`
  background: ${props => props.theme.palette.background.pearl40};
  box-shadow:
    inset 0px -1px 0px ${props => props.theme.palette.background.pearl},
    inset 0px 1px 0px ${props => props.theme.palette.background.pearl};
  padding: 10px 30px;
  line-height: 20px;

  .filter-label {
    margin-bottom: 5px;
  }
`;

export const APIKeyWarning = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;

  .anticon {
    cursor: pointer;
    color: ${props => props.theme.palette.warning};
  }
`;

export const MaskedKeyCell = styled.span`
  display: inline-flex;
  align-items: center;
`;

// -------- FILTER SELECTION STYLES --------
export const DropdownButton = styled(Button)`
  border: 1px solid ${props => props.theme.palette.border};
  border-radius: 5px;
  font-weight: normal;
  display: flex;
  align-items: center;
  padding: 0 10px;

  .anticon {
    color: ${props => props.theme.palette.primary.main};
    margin-top: 4px;
  }
  .anticon-caret-down {
    color: ${props => props.theme.palette.icon.purple} !important;
    align-items: center;
    display: flex;
    font-size: 12px;
    font-style: normal;
    height: 12px;
    line-height: 1;
    margin-top: -6px;
    pointer-events: none;
    position: absolute !important;
    right: 11px;
    text-align: center;
    top: 50%;
  }
  &:hover {
    border: 1px solid ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.text.primary};
  }

  &:active,
  &:focus {
    box-shadow: 0px 0px 2px ${props => props.theme.palette.primary.main};
    border: 1px solid ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.border};
  }
`;

export const StyledCheckboxGroup = styled<any>(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  min-height: 180px;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;

  .ant-checkbox-group-item {
    padding: 7px 10px;
    width: 100%;
    height: 36px;

    &:hover {
      background: ${props => props.theme.palette.background.pearl};
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  height: 36px;
  padding: 7px 10px;
  margin: 0 !important;

  &:hover {
    background: rgb(236, 236, 235);
  }
  &:not(.ant-checkbox-wrapper-disabled):hover,
  :not(.ant-checkbox-wrapper-disabled).ant-checkbox-wrapper-checked {
    border-color: transparent !important;
  }
`;

export const SelectionContainer = styled.div`
  display: flex;
  min-height: 40px;
  margin-top: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.palette.border};
  background: ${props => props.theme.palette.background.light};
  font-size: 16px;
`;

export const SelectionTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-radius: 4px 0 0 4px;
  border-right: 1px solid ${props => props.theme.palette.background.grey2};
  background: ${props => props.theme.palette.background.pearl40};
  color: ${props => props.theme.palette.text.primary80};
`;

export const SelectionItems = styled.div`
  display: flex;
  padding-left: 3px;
  flex-wrap: wrap;
  flex: 1;
`;

export const SelectionItem = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.theme.palette.background.purple20};
  color: ${props => props.theme.palette.text.purpleDarkened3};
  padding: 5px 7px 5px 10px;
  height: 32px;
  border-radius: 16px;
  margin: 3px 5px 3px 0;

  .anticon {
    font-size: 14px;
    margin-left: 7px;
    opacity: 0.2;
    &:hover {
      opacity: 0.4;
    }
  }
`;

export const SelectionButton = styled(Button)`
  margin-top: 2px;
  padding-right: 30px;
  font-size: 16px;
  font-weight: normal;
  color: ${props => props.theme.palette.text.primary} !important;
  min-width: auto;

  .anticon {
    color: ${props => props.theme.palette.border};
    font-size: 16px;
    margin-right: 0px;
    margin-left: 6px;
  }

  &:hover {
    display: relative;
  }
`;

// -------- GROUP MODAL STYLES --------
export const GroupListModal = styled(Modal)`
  .ant-modal-body {
    text-align: center;
    width: 600px;
    background: ${props => props.theme.palette.background.secondary};
    mix-blend-mode: normal;
    box-shadow:
      0px 10px 25px rgba(0, 0, 0, 0.2),
      0px 4px 7px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 30px 60px;

    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 24px;
      color: ${props => props.theme.palette.text.primary};
    }

    div {
      font-size: 16px;
      line-height: 20px;
      text-align: left;

      b {
        font-weight: bold;
        margin-right: 10px;
      }
    }

    .ant-btn {
      margin-top: 25px;
      width: 150px;
      height: 40px;
    }
  }
`;

export const ListContainer = styled(List)`
  padding-top: 5px;
  margin-top: 14px;
  height: 250px;
  overflow: auto;
  font-size: 14px;
  background: ${props => props.theme.palette.background.light};

  .ant-list-item {
    margin: 0 12px;
    padding: 10px 15px;

    &:hover {
      background: none;
    }
  }
`;

// -------- COPY-KEY MODAL STYLES --------
export const StyledModal = styled(Modal)`
  .ant-modal {
    &-content {
      background: ${props => props.theme.palette.background.secondary};
    }
  }
`;

// -------- STYLED MODAL 2 (matches API key modal shading) --------
// API key modal look: pearl-shaded header and footer with a white form body.
// Keeps the modal height constrained and scrolls body content internally.
export const styledModal2Css = `
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
  }
  .ant-modal-header {
    background: #f4f4f3;
    border-bottom: 1px solid #ECECEB;
    padding: 18px 24px;
    border-radius: 8px 8px 0 0;
  }
  .ant-modal-header .ant-modal-title {
    font-size: 22px;
    font-weight: 400;
    line-height: 1.3;
  }
  .ant-modal-body {
    background: #ffffff;
    padding: 0;
  }
  /* Consistent label weight and label-to-control gap across every form item */
  .ant-modal-body .ant-form-item-label {
    padding: 0 0 4px;
  }
  .ant-modal-body .ant-form-item-label > label {
    font-weight: normal;
    height: auto;
  }
  .ant-modal-body .ant-form-item {
    margin-bottom: 16px;
  }
`;

export const StyledModal2 = styled(Modal)`
  ${styledModal2Css}
`;

// Pearl footer band rendered inside the modal body to mimic Service Upload
// Dialog's bottom action strip. Negative margins extend it to the modal edges.
export const ModalFooterBand = styled.div`
  background: #f4f4f3;
  border-top: 1px solid #ececeb;
  margin: 0;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 0 0 auto;

  .ant-btn {
    min-width: auto;
  }
`;

// -------- API KEY TABLE WRAPPER --------
export const ApiKeyTableWrapper = styled.div`
  .ant-table-filter-trigger {
    position: relative;
    display: flex;
    align-items: center;
    margin: -4px -8px -4px 4px;
    margin-right: -8px;
    padding: 0 4px;
    color: #bfbfbf;
    font-size: 12px;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .highlight-row > td {
    background: ${props => props.theme.palette.background.purple20};
    transition: background 0.4s ease-in-out;
  }
`;

// Injected globally because Ant Design renders the picker dropdown into a
// portal outside the table wrapper. Keyed to the `apikey-datepicker-dropdown`
// class set on RangePicker/DatePicker so all API-key calendars look the same.
export const ApiKeyDatePickerGlobalStyles = createGlobalStyle`
  .apikey-datepicker-dropdown .ant-picker-ok .ant-btn {
    border-radius: 2px;
    padding: 0 12px;
    min-width: 60px;
  }
  .apikey-datepicker-dropdown .ant-picker-now-btn {
    color: #512B8B;
    font-weight: 500;
  }
  /* Lay Now far-left and OK far-right in a single footer row, for both the
   * RangePicker (Now comes from renderExtraFooter -> .ant-picker-footer-extra,
   * OK from .ant-picker-ranges) and the DatePicker w/ showTime (both Now and
   * OK live inside .ant-picker-ranges). */
  .apikey-datepicker-dropdown .ant-picker-footer {
    display: flex;
    align-items: center;
    padding: 8px 12px;
  }
  .apikey-datepicker-dropdown .ant-picker-footer-extra {
    padding: 0;
    line-height: 1;
    border: none;
  }
  .apikey-datepicker-dropdown .ant-picker-ranges {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0;
    margin-left: 0;
    line-height: 1;
  }
  .apikey-datepicker-dropdown .ant-picker-ranges .ant-picker-ok {
    margin-left: auto;
  }
`;

export const EmptySearchResults = styled.div`
  padding: 10px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.palette.text.secondary};
`;

export const DropdownContainer = styled.div`
  height: 305px;
  display: flex;
  border-radius: 5px;
  box-shadow:
    0 3px 6px -4px rgb(0 0 0 / 12%),
    0 6px 16px 0 rgb(0 0 0 / 8%),
    0 9px 28px 8px rgb(0 0 0 / 5%);

  .ant-menu {
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: 100%;

    &-item {
      margin: 0;
      background: inherit !important;

      &:first-child {
        border-bottom: 1px solid #f0f0f0;
        padding: 5px 10px;
        height: 50px;
      }

      &:nth-child(2) {
        flex: 1;
        padding: 0;
        height: 180px;
      }

      &:last-child {
        border-top: 1px solid #f0f0f0;
        padding: 0 10px !important;
      }
    }
  }
`;
